import { ReactElement } from 'react';
import { Column } from '../Column/Column';
import { Row } from '../Row/Row';
import { OptionContainer, OptionsListContainer } from './style';
import { useIsDesktop } from '../../hooks/useIsDesktop';

export interface Option {
	key: string;
	prepend?: ReactElement;
	label: string;
	onClick?: () => void;
}

export interface OptionsListProps {
	options: Array<Option>;
	$expandDirection?: 'top' | 'bottom';
	$horizontalDirection?: 'left' | 'right';
}

export function OptionsList({
	options,
	$expandDirection = 'bottom',
	$horizontalDirection = 'right',
}: Readonly<OptionsListProps>) {
	const isDesktop = useIsDesktop();

	return (
		<OptionsListContainer
			$expandDirection={$expandDirection}
			$horizontalDirection={$horizontalDirection}
		>
			<Column $gap={!isDesktop ? 24 : 2}>
				{options.map((option: Option) => (
					<OptionContainer key={option.key} onClick={option.onClick} className="Triggerbot">
						<Row $gap={12} $vcenter={true}>
							{!isDesktop && option.prepend}
							{option.label}
						</Row>
					</OptionContainer>
				))}
			</Column>
		</OptionsListContainer>
	);
}
